import React from 'react';
import { FiArrowDown, FiClock, FiLock } from 'react-icons/fi';
import PublicLayout, { PublicButton } from '../components/public/PublicLayout';

export default function Home() {
    return (
        <PublicLayout>
            <section className="hc-hero hc-container" aria-labelledby="hero-heading">
                <div className="hc-hero-copy">
                    <p className="hc-eyebrow"><span /> HORIZONT MEDICAL CENTER</p>
                    <h1 id="hero-heading">A new horizon.<br /><span>For your health.</span></h1>
                    <p className="hc-hero-description">Welcome to Horizont Clinic.<br />Open every evening, from 17:00 to 20:00.</p>
                    <div className="hc-hero-actions">
                        <PublicButton to="/login">Login</PublicButton>
                        <a className="hc-text-link" href="#opening-hours">Opening hours <FiArrowDown aria-hidden="true" /></a>
                    </div>
                    <div className="hc-hero-signature"><span>HORIZONT</span><span>Medical Center</span></div>
                </div>
                <section id="opening-hours" className="hc-identity-panel" aria-labelledby="hours-heading">
                    <div className="hc-panel-top"><h2 id="hours-heading">OPENING HOURS</h2><FiClock aria-hidden="true" /></div>
                    <div className="hc-hours-display">
                        <p className="hc-hours-day">Monday – Sunday</p>
                        <p className="hc-hours-time"><time dateTime="17:00">17:00</time><span>—</span><time dateTime="20:00">20:00</time></p>
                    </div>
                    <div className="hc-panel-bottom"><p>Evening hours.<br />Every day.</p><span>HORIZONT<br />MEDICAL CENTER</span></div>
                </section>
            </section>
            <section id="staff-access" className="hc-access" aria-labelledby="access-heading">
                <div className="hc-container hc-access-inner">
                    <div className="hc-access-icon"><FiLock aria-hidden="true" /></div>
                    <div className="hc-access-copy">
                        <p className="hc-eyebrow">FOR THE HORIZONT TEAM</p>
                        <h2 id="access-heading">Your workspace, one sign-in away.</h2>
                        <p>Access the clinic management system with your staff account.</p>
                    </div>
                    <PublicButton to="/login">Staff sign in</PublicButton>
                </div>
            </section>
        </PublicLayout>
    );
}
